import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function SeoHead({
  title,
  description,
  ogImage,
  lang = "de",
  faqs = []
}) {
  const { pathname } = useLocation();
  const DOMAIN = "https://edi-converter.de";
  // Canonical ohne #Anker und ohne abschließenden Slash (muss zu Sitemap & statischem HTML passen)
  const canonical = `${DOMAIN}${pathname.replace(/\/+$/, "") || "/"}`;

  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;

    setMeta("description", description);
    setMetaProp("og:title", title);
    setMetaProp("og:description", description);
    setMetaProp("og:image", ogImage);
    setMetaProp("og:url", canonical);

    setLink("canonical", canonical);
    setLink("alternate", canonical, "hreflang", lang);
    setLink("alternate", canonical, "hreflang", "x-default");

    injectJSONLD([
      buildSoftwareLD(title, description, canonical, ogImage),
      ...(faqs.length ? [buildFaqLD(faqs)] : [])
    ]);
  }, [title, description, ogImage, canonical, lang, faqs]);

  return null;
}

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.name = name;
    document.head.appendChild(el);
  }
  el.content = content;
}
function setMetaProp(prop, content) {
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.content = content;
}
function setLink(rel, href, attr = "rel", val = rel) {
  let el = document.querySelector(`link[${attr}="${val}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute(attr, val);
    document.head.appendChild(el);
  }
  el.href = href;
}

/* ---------- JSON‑LD helpers ---------- */
function injectJSONLD(arr) {
  document.querySelectorAll("script[data-ld='auto']").forEach(n => n.remove());
  arr.forEach(obj => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.dataset.ld = "auto";
    s.text = JSON.stringify(obj);
    document.head.appendChild(s);
  });
}
function buildSoftwareLD(name, desc, url, img) {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": name,
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Browser",
    "description": desc,
    "image": img,
    "url": url,
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "EUR" }
  };
}
function buildFaqLD(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(f => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a }
    }))
  };
}
